module.exports = __webpack_public_path__ + "078d726be93fcacb9c3786550b108a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/thumbnails/fundraiser.png
// module id = 919
// module chunks = 4